// Types and pure helpers for the Yotpo-backed product reviews shown on the home
// page and product PDPs — see BNC-5146. The fetch itself lives in reviews.server.ts.

// Mirrors madisongwapi's GET /reviews/:productId response. Every field is always
// present; nullable fields are `null` rather than absent, so no optional chaining
// is needed when reading them.
export type ProductReview = {
  id: string;
  score: number;
  title: string | null;
  content: string | null;
  createdAt: string | null;
  verifiedBuyer: boolean;
  reviewer: {
    displayName: string | null;
    avatarUrl: string | null;
  };
  images: {
    thumbnailUrl: string | null;
    originalUrl: string | null;
  }[];
};

// Bouncie's Yotpo product ID for the OBD device — shared by the home page's
// carousel and the Drive PDP, since both surface reviews for the same product.
export const REVIEWS_PRODUCT_ID = "bouncieobd";

// Sent explicitly so the carousel length does not shift if the BFF's default changes.
export const REVIEWS_PER_PAGE = 10;

// Yotpo can set either URL alone, so both are tried before giving up.
export function firstReviewImageUrl(review: ProductReview): string | null {
  const image = review.images[0];
  if (!image) return null;
  return image.originalUrl ?? image.thumbnailUrl;
}

// UTC-pinned so the rendered month cannot drift by a day depending on the
// viewer's timezone.
export function formatReviewMonth(createdAt: string | null, locale: string): string | null {
  if (!createdAt) return null;
  const date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat(locale, { month: "short", year: "numeric", timeZone: "UTC" }).format(date);
}
